export default {
  Escolaridade: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "grau-de-escolaridade"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Escolaridade.js
// module id = Dwt2
// module chunks = 18